import { StyleSheet, ActivityIndicator } from 'react-native'
import styled from 'styled-components/native'

import { getColourScheme, ColourScheme } from 'APP/Helpers/AppearanceUtils'
import Typography from 'APP/Converse/Typography'
import { ApplicationStyles } from 'APP/Themes'

export const createStyles = (theme) =>
  StyleSheet.create({
    container: {
      paddingHorizontal: theme.metrics.baseMargin * 1.75,
      paddingBottom: theme.metrics.bottomSpace,
    },
    guidanceBar: {
      padding: theme.metrics.baseMargin * 1.25,
      backgroundColor: theme.colors.tagBg,
      borderRadius: 16,
      display: 'flex',
      flexDirection: 'row',
    },
    guidanceText: {
      ...theme.fonts.styles.body,
      color: theme.colors.darkText,
      marginLeft: theme.metrics.baseMargin * 0.75,
      flex: 1,
    },
    bold: {
      fontFamily: theme.fonts.fontTypes.bold,
    },
    titleContainer: {
      backgroundColor: theme.colors.contrastElementBg,
      paddingVertical: theme.metrics.baseMargin * 0.5,
    },
    listWrapper: {
      ...ApplicationStyles.shadow,
      marginBottom: theme.metrics.baseMargin,
      marginTop: theme.metrics.baseMargin,
    },
    list: {
      ...ApplicationStyles.shadow,
      backgroundColor: theme.colors.elementsBg,
      borderRadius: 10,
      overflow: 'hidden',
    },
    listItemProcessing: {
      position: 'absolute',
      right: 5,
    },
    customMessageInputHintContainer: {
      ...ApplicationStyles.screen.formInputHelpText,
      color: theme.colors.textButtonSelected,
      paddingVertical: theme.metrics.baseMargin * 0.5,
      marginHorizontal: theme.metrics.baseMargin / 2,
      marginTop: 0,
      marginBottom: 0,
      paddingHorizontal: 0,
    },
    customMessageInputHintText: {
      ...theme.fonts.styles.bodySmall,
      textAlign: 'right',
      color: theme.colors.textButtonSelected,
    },
    customMessageSubmitButton: {
      ...ApplicationStyles.screen.primaryButton,
      marginHorizontal: 0,
      borderRadius: 30,
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
    },
    viewOptionsCta: {
      margin: 0,
    },
  })

export const StyledPromptOptionTitle = styled(Typography).attrs(() => ({
  variant: 'bodySmallBold',
  align: 'center',
}))`
  width: 100%;
`

export const StyledPromptOption = styled(Typography).attrs(() => ({
  variant: 'subheader',
  align: 'center',
}))`
  width: 100%;
`

export const StyledHighlightedPromptOption = styled(StyledPromptOption)`
  color: ${({ theme: { colors } }) =>
    getColourScheme() === ColourScheme.DARK ? colors.darkText : colors.text};
`

export const StyledActivityIndicator = styled(ActivityIndicator).attrs(({ theme }) => ({
  color: theme.colors.text,
  size: 20,
  testID: 'promptOptionLoading',
}))``

export const StyledHighlightedActivityIndicator = styled(StyledActivityIndicator).attrs(
  ({ theme: { colors } }) => ({
    color: getColourScheme() === ColourScheme.DARK ? colors.darkText : colors.text,
  })
)``

export const StyledGuidanceText = styled(Typography).attrs(() => ({
  variant: 'bodyNormal',
  color: 'darkText',
}))`
  margin-left: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  flex: 1;
`
